import withNoListingsData from './container';
import NoListingsEventView from './NoListingsEventView';
import NoListingsFilterView from './NoListingsFilterView';

export const NoListingEvent = withNoListingsData(NoListingsEventView);

export const NoListingFilter = withNoListingsData(NoListingsFilterView);
